import { render, staticRenderFns } from "./CompanyMultiRestaurantTabRestaurantMeals.vue?vue&type=template&id=69d67004&scoped=true"
import script from "./CompanyMultiRestaurantTabRestaurantMeals.vue?vue&type=script&lang=js"
export * from "./CompanyMultiRestaurantTabRestaurantMeals.vue?vue&type=script&lang=js"
import style0 from "./CompanyMultiRestaurantTabRestaurantMeals.vue?vue&type=style&index=0&id=69d67004&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69d67004",
  null
  
)

export default component.exports